/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { BaseComponentDelegate } from '../core/delegates/base-component-delegate';
import { BUTTON_CONSTANTS } from './button-constants';
export class ButtonComponentDelegate extends BaseComponentDelegate {
    constructor(config) {
        super(config);
    }
    _build() {
        const component = document.createElement(BUTTON_CONSTANTS.elementName);
        if (this._config.options?.variant) {
            component.variant = this._config.options.variant;
        }
        if (this._config.options?.type) {
            component.type = this._config.options.type;
        }
        if (this._config.options?.text) {
            component.textContent = this._config.options.text;
        }
        return component;
    }
    onClick(listener) {
        this._element.addEventListener('click', listener);
    }
    onFocus(listener) {
        this._element.addEventListener('focus', evt => listener(evt));
    }
    onBlur(listener) {
        this._element.addEventListener('blur', evt => listener(evt));
    }
}
